import React from "react"

export function Users(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="18"
      height="14"
      viewBox="0 0 18 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.625 3.5C2.625 2.57174 2.99375 1.6815 3.65013 1.02513C4.3065 0.368749 5.19674 0 6.125 0C7.05326 0 7.9435 0.368749 8.59987 1.02513C9.25625 1.6815 9.625 2.57174 9.625 3.5C9.625 4.42826 9.25625 5.3185 8.59987 5.97487C7.9435 6.63125 7.05326 7 6.125 7C5.19674 7 4.3065 6.63125 3.65013 5.97487C2.99375 5.3185 2.625 4.42826 2.625 3.5ZM0 13.1879C0 10.4945 2.18203 8.3125 4.87539 8.3125H7.37461C10.068 8.3125 12.25 10.4945 12.25 13.1879C12.25 13.6363 11.8863 14 11.4379 14H0.812109C0.363672 14 0 13.6363 0 13.1879ZM16.6605 14H12.8898C13.0375 13.743 13.125 13.4449 13.125 13.125V12.9062C13.125 11.2465 12.384 9.75625 11.2164 8.75547C11.282 8.75274 11.3449 8.75 11.4105 8.75H13.0895C15.5258 8.75 17.5 10.7242 17.5 13.1605C17.5 13.6254 17.1227 14 16.6605 14ZM11.8125 7C10.9648 7 10.1992 6.65547 9.64414 6.10039C10.1828 5.37305 10.5 4.47344 10.5 3.5C10.5 2.76719 10.3195 2.07539 9.99961 1.46836C10.5082 1.09648 11.1344 0.875 11.8125 0.875C13.5051 0.875 14.875 2.24492 14.875 3.9375C14.875 5.63008 13.5051 7 11.8125 7Z"
        fill="currectColor"
      />
    </svg>
  )
}
